import { render } from "./SameDayTable.vue?vue&type=template&id=27a2006a&scoped=true"
import script from "./SameDayTable.vue?vue&type=script&lang=js"
export * from "./SameDayTable.vue?vue&type=script&lang=js"

import "./SameDayTable.vue?vue&type=style&index=0&id=27a2006a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a2006a"]])

export default __exports__